module.exports = __webpack_public_path__ + "static/media/back-aqua.6c22163f.png";